/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CognitoChallengeParameters } from './CognitoChallengeParameters';
import {
    CognitoChallengeParametersFromJSON,
    CognitoChallengeParametersFromJSONTyped,
    CognitoChallengeParametersToJSON,
} from './CognitoChallengeParameters';
import type { CognitoChallengeNameSchema } from './CognitoChallengeNameSchema';
import {
    CognitoChallengeNameSchemaFromJSON,
    CognitoChallengeNameSchemaFromJSONTyped,
    CognitoChallengeNameSchemaToJSON,
} from './CognitoChallengeNameSchema';
import type { CognitoAuthenticationResult } from './CognitoAuthenticationResult';
import {
    CognitoAuthenticationResultFromJSON,
    CognitoAuthenticationResultFromJSONTyped,
    CognitoAuthenticationResultToJSON,
} from './CognitoAuthenticationResult';

/**
 * Login Response
 * @export
 * @interface LoginAccount200Response
 */
export interface LoginAccount200Response {
    /**
     * 
     * @type {CognitoChallengeNameSchema}
     * @memberof LoginAccount200Response
     */
    challengeName?: CognitoChallengeNameSchema;
    /**
     * Username
     * @type {string}
     * @memberof LoginAccount200Response
     */
    username?: string;
    /**
     * Session Token
     * @type {string}
     * @memberof LoginAccount200Response
     */
    session?: string;
    /**
     * 
     * @type {CognitoAuthenticationResult}
     * @memberof LoginAccount200Response
     */
    authenticationResult?: CognitoAuthenticationResult;
    /**
     * 
     * @type {CognitoChallengeParameters}
     * @memberof LoginAccount200Response
     */
    challengeParameters?: CognitoChallengeParameters;
}



/**
 * Check if a given object implements the LoginAccount200Response interface.
 */
export function instanceOfLoginAccount200Response(value: object): value is LoginAccount200Response {
    return true;
}

export function LoginAccount200ResponseFromJSON(json: any): LoginAccount200Response {
    return LoginAccount200ResponseFromJSONTyped(json, false);
}

export function LoginAccount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginAccount200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'challengeName': json['challengeName'] == null ? undefined : CognitoChallengeNameSchemaFromJSON(json['challengeName']),
        'username': json['username'] == null ? undefined : json['username'],
        'session': json['session'] == null ? undefined : json['session'],
        'authenticationResult': json['authenticationResult'] == null ? undefined : CognitoAuthenticationResultFromJSON(json['authenticationResult']),
        'challengeParameters': json['challengeParameters'] == null ? undefined : CognitoChallengeParametersFromJSON(json['challengeParameters']),
    };
}

export function LoginAccount200ResponseToJSON(value?: LoginAccount200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'challengeName': CognitoChallengeNameSchemaToJSON(value['challengeName']),
        'username': value['username'],
        'session': value['session'],
        'authenticationResult': CognitoAuthenticationResultToJSON(value['authenticationResult']),
        'challengeParameters': CognitoChallengeParametersToJSON(value['challengeParameters']),
    };
}

